import * as React from "react";
import { SVGProps, memo } from "react";

const SvgReceptionist = (props: SVGProps<SVGSVGElement>) => (
  <svg width={90} height={118} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#Receptionist_svg__a)">
      <path
        d="M74.086 77.742s-3.338-1.109-6.348-2.728c-.874-.47-2.4-1.924-2.851-2.74a8.05 8.05 0 0 1-.874-2.388c-.91-4.646-.276-9.75-.276-9.75s-3.66-2.253-6.307-2.3h-.27c-2.646.041-6.306 2.3-6.306 2.3s.181 5.133-.276 9.75c-.059.57-.346 1.42-.88 2.388-.452.822-1.977 2.27-2.852 2.74-3.003 1.62-6.347 2.728-6.347 2.728-1.285.57-2.424 2.916-1.796 5.116.857 3.027 2.898 3.602 5.216 4.26.61.17 1.22.357 2.176.522 3.99.68 8.167 1.384 11.2 1.003 3.033.381 7.21-.329 11.2-1.003.962-.165 1.567-.352 2.177-.522 2.317-.658 4.359-1.233 5.215-4.26.622-2.2-.51-4.547-1.795-5.116h-.006Z"
        fill="#fff"
      />

      <path
        d="M74.086 77.742s-3.338-1.109-6.348-2.728c-.874-.47-2.4-1.924-2.851-2.74a8.05 8.05 0 0 1-.874-2.388c-.91-4.646-.276-9.75-.276-9.75s-3.66-2.253-6.307-2.3h-.27c-2.646.041-6.306 2.3-6.306 2.3s.181 5.133-.276 9.75c-.059.57-.346 1.42-.88 2.388-.452.822-1.977 2.27-2.852 2.74-3.003 1.62-6.347 2.728-6.347 2.728-1.285.57-2.424 2.916-1.796 5.116.857 3.027 2.898 3.602 5.216 4.26.61.17 1.22.357 2.176.522 3.99.68 8.167 1.384 11.2 1.003 3.033.381 7.21-.329 11.2-1.003.962-.165 1.567-.352 2.177-.522 2.317-.658 4.359-1.233 5.215-4.26.622-2.2-.51-4.547-1.795-5.116h-.006Z"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M40.422 79.121c9.13.957 18.44.962 27.545-.082-.005.035-.011.065-.011.246 3.15 2.998 5.374 6.524 6.441 10.232.34 1.174.564 2.359.787 3.544.387 2.036.768 4.071 1.155 6.107.317 1.672.628 3.339.886 5.016 1.42 9.305 1.015 18.716 2.476 28.044-.17.176-.076.452.2.528 0 .018-.012.035-.106.012-3.338.997-7.023 1.115-10.619 1.22-4.999.147-9.991.294-14.99.434-3.186.094-6.377.188-9.551-.011-5.35-.335-10.531-1.485-15.665-2.635a91.77 91.77 0 0 1 1.66-19.836c1.368-7.052 3.562-14.01 4.677-21.085.299-1.913.527-3.849 1.237-5.703.798-2.088 2.195-4.019 3.878-6.043v.012Z"
        fill="#CAECD1"
        stroke="#272C33"
        strokeWidth={1.848}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M41.396 78.515s.364-1.942-1.866-.945c-1.42.634-6.183 3.802-6.183 3.802A35.47 35.47 0 0 0 22.604 95.54c-1.132 2.722-1.918 5.574-2.698 8.419-2.112 7.674-5.41 21.133-4.23 25.914.54 2.2 19.965 5.392 20.739 1.872.757-3.415 1.197-8.953 1.197-8.953"
        fill="#fff"
      />

      <path
        d="M41.396 78.515s.364-1.942-1.866-.945c-1.42.634-6.183 3.802-6.183 3.802A35.47 35.47 0 0 0 22.604 95.54c-1.132 2.722-1.918 5.574-2.698 8.419-2.112 7.674-5.41 21.133-4.23 25.914.54 2.2 19.965 5.392 20.739 1.872.757-3.415 1.197-8.953 1.197-8.953"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M37.612 122.791c.287-2.968.716-5.755 1.009-8.783 1.384-14.25 4.16-28.665 8.736-40.27-.957.27-2.64.716-3.526 1.062-1.127.44-2.54.892-2.858 1.127-.727.551-8.923 12.9-10.442 15.224-.159.247-.323.505-.364.792-.053.346-.047.757.182 1.027.756.903 1.96 2.364 3.602 3.978-1.66 1.625-2.03 2.059-3.497 3.52-.176.176-.633.692-.745.915-.146.305-.035.622-.012.71.17.616 2.852 11.065 5.685 19.548"
        fill="#fff"
      />

      <path
        d="M37.612 122.791c.287-2.968.716-5.755 1.009-8.783 1.384-14.25 4.16-28.665 8.736-40.27-.957.27-2.64.716-3.526 1.062-1.127.44-2.54.892-2.858 1.127-.727.551-8.923 12.9-10.442 15.224-.159.247-.323.505-.364.792-.053.346-.047.757.182 1.027.756.903 1.96 2.364 3.602 3.978-1.66 1.625-2.03 2.059-3.497 3.52-.176.176-.633.692-.745.915-.146.305-.035.622-.012.71.17.616 2.852 11.065 5.685 19.548"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M86.976 129.955c-3.227 10.548-40.886 12.925-50.08 4.588-7.914-7.181 9.733-21.872 10.027-24.876 1.63-16.538 20.446-31.81 27.105-31.13 14.327 1.467 17.489 36.551 12.942 51.418h.006Z"
        fill="#fff"
      />

      <path
        d="M41.413 123.255S54.408 86.827 66.7 70.547c1.543.358 1.314 1.408 2.306 1.977.352.205.381 3.48.428 3.884.264 2.27-.974 2.998-.416 5.779.557 2.78-1.303 9.522-2.007 12.743-.064.287-.193.968-.281 1.25-.1.334-.317.65-.61.85-1.514 1.044-6.055 1.056-7.616 1.819.429.833.44 2.722 1.15 5.033.07.241.2.546.2.792a.887.887 0 0 1-.294.646c-5.116 4.47-13.188 12.878-15.5 17.014"
        fill="#fff"
      />

      <path
        d="M41.413 123.255S54.408 86.827 66.7 70.547c1.543.358 1.314 1.408 2.306 1.977.352.205.381 3.48.428 3.884.264 2.27-.974 2.998-.416 5.779.557 2.78-1.303 9.522-2.007 12.743-.064.287-.193.968-.281 1.25-.1.334-.317.65-.61.85-1.514 1.044-6.055 1.056-7.616 1.819.429.833.44 2.722 1.15 5.033.07.241.2.546.2.792a.887.887 0 0 1-.294.646c-5.116 4.47-13.188 12.878-15.5 17.014"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M71.804 104.246c-.464 5.497-1.807 9.276-2.335 22.247l2.335-22.247Z" fill="#fff" />

      <path
        d="M71.804 104.246c-.464 5.497-1.807 9.276-2.335 22.247"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M67.433 75.61c2.47 1.055 5.62 3.76 6.87 4.57l-6.87-4.57Z" fill="#fff" />

      <path
        d="M67.433 75.61c2.47 1.055 5.62 3.76 6.87 4.57M76.614 77.856c3.509 3.367 5.65 5.022 8.601 10.231.593 1.045 2.124 5.151 2.793 10.209 1.226 9.246 1.068 13.617.446 18.774"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M59.636 83.623c-5.18 3.068-4.441 10.425.722 12.29-3.831-13.118 18.41-9.504 16.562-25.438-.34-2.934-.399-6.735-5.122-12.456-1.42-2.217-3.802-.557-2.746 1.385 1.344 4.629-4.681 10.701-8.043 12.878-4.905 2.147-7.422 6.882-4.817 11.698-.264.07-.293 4.7.622 5.392"
        fill="#2BA168"
      />

      <path
        d="M62.4 3.282a34.035 34.035 0 0 0-13.495-.734A33.829 33.829 0 0 0 36.58 6.92l.03.018c-2.253.733-7.105 2.67-10.89 7.462-5.303 6.718-4.828 14.38-4.67 16.98.376 6.036 2.664 10.231 5.979 16.31 3.074 5.631 4.899 8.97 8.05 11.486 9.65 7.704 25.021 2.359 27.68 1.391 2.305-.276 7.696-1.244 12.66-5.45 5.397-4.582 7.046-10.256 7.732-12.75 3.638-13.2-3.866-24.593-5.526-26.97-4.318-6.183-9.769-9.668-13.512-11.533-.569-.194-1.138-.382-1.713-.575v-.006Z"
        fill="#2BA168"
      />

      <path
        d="M55.735 84.435c-1.127-1.93-1.279-4.523-.458-6.624.698-1.783 2.605-3.203 4.207-4.218 2.927-1.842 5.433-3.385 7.369-6.143 1.93-2.751 2.91-4.98 2.17-7.527 0 0 .06.023 1.28-.675 1.765-1.015 1.736-.856 1.736-.856 4.916 5.761 5.362 9.745 5.374 12.725.012 2.98-.686 6.583-2.898 8.554-1.819 1.625-3.597 3.098-5.82 4.072-2.259.997-3.256 1.678-5.21 3.203-1.66 1.296-2.816 2.828-3.456 4.858-.639 2.03.3 4.763.3 4.763-1.731-1.472-3.28-2.364-4.183-4.488-.67-1.578-1.69-5.714-.417-7.632"
        stroke="#272C33"
        strokeWidth={2.306}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M63.707 4.268c-1.138-.481-11.57-4.7-23.039-.27a30.083 30.083 0 0 0-6.055 3.18l.03.018c-7.076 3.144-10.737 8.817-12.684 14.749-3.655 11.117-.077 17.923 3.848 22.875 4.383 5.526 20.159 19.267 21.408 19.39 4.09.399 7.516-.041 9.863-.516 2.927-.482 7.967-1.702 13.136-5.204 2.235-1.514 8.712-6.032 11.786-14.445 5.18-14.162-3.749-27.093-5.04-28.894C75.495 13.103 71.4 7.524 63.707 4.28v-.012Z"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.175 69.602c1.531.182 4.318.135 6.143-.047l-.075-3.047.286-.07c1.915-.467 3.607-.653 4.987-.804 2.352-.258 3.795-.416 3.884-1.696.008-.123.014-.252.02-.386.046-1.033.103-2.338 1.646-2.893.545-.2 1.19-.458 1.813-.88 0 0 .451-.517.774-1.497.165-.496.114-.99.052-1.578-.085-.81-.188-1.796.23-3.209 3.01-.833 5.497-3.38 6.177-6.406.27-1.197.27-2.476-.164-3.626-.434-1.15-1.326-2.153-2.487-2.564-1.156-.41-2.564-.164-3.233.334.475-6.512-1.109-13.153-4.465-18.756-1.472-2.458-3.315-4.74-5.673-6.372-1.56-1.073-3.304-1.828-5.133-2.322l-.03-1.236c-1.98.123-3.968.248-5.94.473h-.167c-3.927 0-7.807.792-11.658 1.579l-.082.016.45 1.764c-1.664.962-3.175 2.159-4.416 3.625-1.854 2.188-3.027 4.875-3.807 7.633a32.203 32.203 0 0 0 .592 19.272c-.774-.3 5.662 16.521 9.645 18.569 4.788 2.464 7.803 3.784 10.631 4.124Z"
        fill="#fff"
      />

      <path
        d="M56.403 65.535a20.244 20.244 0 0 1-7.075 2.5c-2.816.428-5.327.193-6.853-.141-8.208-1.807-11.95-9.54-13.124-12.156 0 0-5.949-12.38-3.802-27.745.217-1.566.716-4.928 2.77-8.137a17.946 17.946 0 0 1 2.616-3.22s1.396-1.356 3.256-2.506c1.273-.786 6.747-2.746 14.532-3.92"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M66.97 60.407c-1.074-2.634-.875-3.443.152-6.917 3.11-.862 5.679-3.49 6.383-6.617.282-1.238.282-2.564-.17-3.75-.446-1.184-1.373-2.223-2.57-2.645-1.197-.429-2.652-.165-3.338.34-.07-3.726-.64-12.631-5.538-20.07-2.652-4.031-5.357-5.78-5.985-6.173-2.962-1.86-5.708-2.329-7.756-2.657-6.136-.992-11.012 1.525-14.52 2.716"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="Receptionist_svg__b"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={30}
        y={33}
        width={7}
        height={6}
      >
        <path d="M36.973 33.691h-6.917v4.618h6.917V33.69Z" fill="#fff" />
      </mask>

      <g mask="url(#Receptionist_svg__b)">
        <path
          d="M36.328 34.336a9.174 9.174 0 0 0-5.627 3.327"
          stroke="#272C33"
          strokeWidth={1.291}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="Receptionist_svg__c"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={61}
        y={28}
        width={9}
        height={7}
      >
        <path d="m68.35 28.601-6.676 1.81 1.207 4.456 6.677-1.81-1.208-4.456Z" fill="#fff" />
      </mask>

      <g mask="url(#Receptionist_svg__c)">
        <path
          d="M62.47 30.858a9.167 9.167 0 0 1 6.3 1.743"
          stroke="#272C33"
          strokeWidth={1.291}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M41.343 52.66a5.73 5.73 0 0 0 .317 2.288"
        stroke="#272C33"
        strokeWidth={1.719}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="Receptionist_svg__d"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={31}
        y={45}
        width={6}
        height={6}
      >
        <path d="M36.937 45.3h-5.034v5.645h5.034V45.3Z" fill="#fff" />
      </mask>

      <g mask="url(#Receptionist_svg__d)">
        <path
          d="M35.077 50.924c1.211-.161 2.027-1.539 1.822-3.077-.205-1.539-1.352-2.655-2.563-2.494-1.21.16-2.026 1.539-1.822 3.077.205 1.539 1.353 2.655 2.563 2.494Z"
          fill="#272C33"
        />

        <path
          d="M32.549 45.945c.276.235.557.47.833.704"
          stroke="#272C33"
          strokeWidth={1.291}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="Receptionist_svg__e"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={49}
        y={42}
        width={8}
        height={8}
      >
        <path d="m54.814 42.254-4.859 1.316 1.476 5.448L56.29 47.7l-1.476-5.447Z" fill="#fff" />
      </mask>

      <g mask="url(#Receptionist_svg__e)">
        <path
          d="M53.21 48.51c1.211-.161 2.027-1.539 1.822-3.077-.205-1.539-1.352-2.655-2.563-2.494-1.211.16-2.027 1.539-1.822 3.077.205 1.539 1.352 2.655 2.563 2.494Z"
          fill="#272C33"
        />

        <path
          d="M54.356 43.043c-.205.3-.416.598-.622.898"
          stroke="#272C33"
          strokeWidth={1.291}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M60.727 35.849c-2.458-.041-8.16.968-14.309-3.168-5.52-3.708-10.032-11.06-11.112-13.289-.03 2.588 1.197 8.326-1.467 13.441-3.737 7.164-5.162 9.546-7.474 10.743-1.085-.84-1.443-1.649-2.095-2.893-.592-1.126-.258-2.153-.569-3.385-.393-1.543-.357-4.646-.275-6.236.058-1.098.223-2.26.493-3.685.58-3.068 1.185-6.236 2.95-9.469 2.306-4.218 5.521-6.553 7.158-7.72 4.993-3.55 9.839-4.354 11.294-4.553a24.156 24.156 0 0 1 3.532-.223C55 5.506 59.425 8.046 61.22 9.108c3.673 2.17 5.92 4.67 6.6 5.456 7.217 8.337 6.366 18.217 6.032 20.07-.118.652-.523 2.922-.875 2.899-.053 0-1.279 1.766-1.302 1.73"
        fill="#2BA168"
      />

      <path
        d="M25.808 43.125c7.879-5.996 9.569-13.306 10.09-24.36a28.87 28.87 0 0 0 4.412 8.12c1.086 1.403 3.268 4.172 7.023 6.471 4.776 2.922 10.39 3.157 13.03 3.25"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M47.95 22.516a30.128 30.128 0 0 0 6.676 9.316c5.761 5.433 10.179 6.12 13.124 6.694"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M25.016 102.02c-2.094 9.117-2.799 19.184-3.309 28.196"
        stroke="#272C33"
        strokeWidth={1.948}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M42.78 58.907s-.047 1.966 1.614 2.987c1.39.856 3.667.569 4.629-.247 1.684-1.431 1.109-3.655 1.109-3.655-2.306.247-5.046.675-7.352.921v-.006Z"
        stroke="#272C33"
        strokeWidth={1.625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M2.798 79.515c-.605 2.904-1.197 7.24 2.388 9.323l-.2 7.18 10.52.605c-1.274-6.354 1.842-11.335 3.543-16.996.317-1.954-.458-1.027-.405-6.677.059-6.43.112-10.508.188-11.07-.03-1.638-.3-3.357-1.919-3.357-2.035 0-2.035 2.799-2.053 3.614-.088 4.254-.023 7.61-.434 7.956-.053.023-.13.123-.182.041-.91-1.46-4.764-1.877-6.02.587-1.883-.528-2.862.064-3.302.985 0 0-.95.035-1.655.329-2.094 1.332-1.913 6.606-.17 7.515.78.388 2.599-.129 2.599-.129s1.12.206 1.73.13c.846-.106 1.192-.546 1.808-.722 1.15.21 3.649-.54 4.036-1.045.247-.316.792-1.226.217-3.22"
        fill="#fff"
      />

      <path
        d="M2.798 79.515c-.605 2.904-1.197 7.24 2.388 9.323l-.2 7.18 10.52.605c-1.274-6.354 1.842-11.335 3.543-16.996.317-1.954-.458-1.027-.405-6.677.059-6.43.112-10.508.188-11.07-.03-1.638-.3-3.357-1.919-3.357-2.035 0-2.035 2.799-2.053 3.614-.088 4.254-.023 7.61-.434 7.956-.053.023-.13.123-.182.041-.91-1.46-4.764-1.877-6.02.587-1.883-.528-2.862.064-3.302.985 0 0-.95.035-1.655.329-2.094 1.332-1.913 6.606-.17 7.515.78.388 2.599-.129 2.599-.129s1.12.206 1.73.13c.846-.106 1.192-.546 1.808-.722 1.15.21 3.649-.54 4.036-1.045.247-.316.792-1.226.217-3.22"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M16.908 78.461c-2.335-1.619-3.191-7.263-6.172-4.992-.956 1.52 1.355 6.735 1.355 6.735s-1.842 2.13-2.03 3.39"
        fill="#fff"
      />

      <path
        d="M16.908 78.461c-2.335-1.619-3.191-7.263-6.172-4.992-.956 1.52 1.355 6.735 1.355 6.735s-1.842 2.13-2.03 3.39"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M20.521 122.347c-.428 1.22-1.443 1.643-1.443 1.643-4.066 3.625-11.475.387-13.834-3.532-1.701-2.828-1.66-20.787-1.443-26.554 6.87-1.402 10.607-2.258 12.766-1.103.71 3.444 4.336 19.877 4.676 24.031l-.727 5.509.006.006Z"
        fill="#fff"
      />

      <path
        d="M19.595 124.884c-2.482 1.795-4.934 1.948-7.117 1.408-1.038-.252-3.772-1.156-6.125-3.385-1.596-1.508-2.417-3.421-3.291-8.478-.575-3.332.017-16.128.633-21.355 0 0 3.286-.487 6.53-.822 2.646-.275 6.266.012 6.266.012 1.273 5.45 3.285 20.798 3.285 20.798"
        stroke="#272C33"
        strokeWidth={2.153}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <clipPath id="Receptionist_svg__a">
        <path fill="#fff" transform="translate(.662 .918)" d="M0 0h89.177v116.164H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgReceptionist);

export default Memo;
